<template>
    <div class="card" v-loading="loading">
        <div class="card-favorite" v-if="authCheck">
            <a class="active" href="javascript:;" @click="likeToggle"><i :class="likeHeartClass"></i></a>
        </div>
        <img class="card-img-top" :src="thumbImage" alt="Card image cap">
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <template v-if="industries.length">
                <span v-for="industry in industries" class="badge badge-primary mr-1 mb-1">
						{{ industry.name.en }}
                </span>
            </template>
            <p v-html="cardBody"></p>
            <p class="text-right mb-0">
                <a :href="url" class="link-more">
                    Learn more <i class="icon-arrow-right"></i>
                </a>
            </p>
        </div>

    </div>
</template>

<script>
    import helpers from './../../components/Helpers';

    export default {
        mixins: [helpers],
        props: {
            authCheck: {
                required: true
            },
            industries:{
                default(){
                    return []
                }
            },
            image: {
                default: null,
            },
            title: {
                default: "N/A"
            },
            description: {
                default: "N/A"
            },
            url: {
                default: "#"
            },
            idx: {
                required: true
            },
            initialLike: {
                required: false,
                default: false,
            },
            jobId:{
                required:true,
            }

        },

        data() {
            return {
                thumbImage: '',
                like:false,
                loading:false,
            }
        },
        computed: {
            cardBody() {
                return this.description.length > 125 ? this.description.substr(0, 125) + "..." : this.description;
            },
            modalImage() {
                return 'background: url("' + this.thumbImage + '")';
            },
            likeHeartClass() {
                return this.like ? 'fas fa-heart' : 'far fa-heart';
            },
            routes() {
                return {
                    like: window.App.routes.api.jobs_like,
                    dislike: window.App.routes.api.jobs_dislike,
                    show: window.App.routes.web.jobs_show.replace('NUM',this.jobId)
                }
            },
        },
        methods: {
            showModal() {
                $('#jobModal_' + this.idx).modal('show');
            },
            likeToggle() {
                this.loading = true;
                let callSetting = {
                    method: "post",
                    route: this.routes.like,
                }
                if (this.like) {
                    callSetting.method = "put";
                    callSetting.route = this.routes.dislike;
                }
                axios({
                    method: callSetting.method,
                    url: callSetting.route,
                    data: {
                        job: this.jobId
                    }
                }).then((response) => {
                    this.like = !this.like;
                    this.loading = false;
                }).catch(e => console.log(e));
            }
        },
        mounted() {
            this.thumbImage = this.image || this.getFallBackImage();
            this.like = this.initialLike
        }
    }
</script>

<style>


</style>



// WEBPACK FOOTER //
// resources/assets/js/views/jobs/JobCard.vue